import { motion } from "framer-motion";
import { useLang } from "@/i18n";

const BG =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_water-sports-reserve/artifacts/d1iunwsh_1000132190.jpg";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="circolo" data-testid="manifesto-section" className="relative bg-lake-deep py-24 sm:py-32 grain overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.12] bg-cover bg-center"
        style={{ backgroundImage: `url(${BG})` }}
      />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold mb-4">{t.manifesto.eyebrow}</p>
          <h2 className="font-serif text-3xl sm:text-5xl tracking-tight text-glacier max-w-2xl leading-[1.08]">
            {t.manifesto.title}
          </h2>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16">
          {t.manifesto.chapters.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`manifesto-chapter-${c.n}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 2) * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className={`border-t hairline-light pt-8 ${i % 2 === 1 ? "md:mt-16" : ""}`}
            >
              <span className="font-serif text-6xl sm:text-7xl text-outline block leading-none">{c.n}</span>
              <h3 className="mt-6 font-serif text-2xl sm:text-3xl text-glacier tracking-tight">{c.title}</h3>
              <p className="mt-4 text-glacier/65 leading-relaxed text-base">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
